import React from "react";

function Clock_Hands() {
  return (
    <div>
      <h1>Clock_Hands Component</h1>
      <p>This is the Clock Hands tutorial page content.</p>
    </div>
  );
}

export default Clock_Hands;
